<template>
  <button class="theme-toggle" type="button" aria-label="Alternar tema" @click="toggleTheme">
    <svg class="icon-moon" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8">
      <path d="M21 14.3A8.5 8.5 0 1 1 9.7 3 7 7 0 0 0 21 14.3z"/>
    </svg>
    <svg class="icon-sun" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8">
      <circle cx="12" cy="12" r="4"/>
      <path d="M12 3v2M12 19v2M5 12H3M21 12h-2M6.2 6.2l1.4 1.4M16.4 16.4l1.4 1.4M17.8 6.2l-1.4 1.4M7.6 16.4l-1.4 1.4"/>
    </svg>
  </button>
</template>

<script>
import { toggleTheme } from "@/helpers/theme";

export default {
  name: "ThemeToggle",
  methods: {
    toggleTheme,
  },
};
</script>
